import { useParams } from 'react-router';

import useAccountQuery from 'api/queries/useAccountQuery';
import useSearchQuery from 'api/queries/useSearchQuery';
import AisleContent from 'features/shop/AisleContent';
import Loader from 'honeydew/Loader';
import { formatString } from 'utils/globalUtils';

function Brand() {
    const { brand } = useParams();

    const { data: account = {} } = useAccountQuery();
    const { data: queryData = {}, isLoading } = useSearchQuery(brand, brand);
    const { items = [], noResults } = queryData;

    if (!account || isLoading || !brand || !items) {
        return (
            <div className="flex h-[300px] items-center justify-center">
                <Loader width="60px" />
            </div>
        );
    }

    const brandName =
        items.length && formatString(items[0]?.brand, ' ', ',') === formatString(brand, ' ', '+')
            ? items[0]?.brand
            : formatString(brand, ' ', '+');

    return (
        <AisleContent
            isLoading={isLoading}
            currentAisle={{
                id: 0,
                name: brandName,
                count: noResults ? 0 : items.length,
                inStockCount: noResults ? 0 : items.length,
            }}
            items={items}
            searchQuery={brandName}
            brandPage
        />
    );
}

export { Brand as Component };
